export default "__VITE_ASSET__CtEM0Ay7__"